import FujiLogo from "src/assets/images/home/FujiLogo.svg";
import GoLogo from "src/assets/images/home/GoLogo.svg";
import HaproLogo from "src/assets/images/home/HaproLogo.svg";
import LotteLogo from "src/assets/images/home/LotteLogo.svg";
import TeekiuLogo from "src/assets/images/home/TeekiuLogo.svg";
import VinLogo from "src/assets/images/home/VinLogo.svg";
import ImageExample from "src/assets/images/home/example.svg";
import ImagesHomeNearYou1 from "src/assets/images/home/Rectangle_6019.png";
import ImagesHomeNearYou2 from "src/assets/images/home/Rectangle_6019_2.png";
import ImagesHomeNearYou3 from "src/assets/images/home/Rectangle_6019_3.png";
import LotteLogoEllipe from "src/assets/images/home/LotteLogoEllipe.png";
import TeekiuLogoEllipe from "src/assets/images/home/TekkuLogoEllipe.png";
import GoLogoEllipe from "src/assets/images/home/GoLogoEllipe.png";
import HPMLogoEllipe from "src/assets/images/home/HPMLogoEllipe.png";
import VinLogoEllipe from "src/assets/images/home/VinLogoEllipe.png";

import LemonPound from "src/assets/images/home/BakeryBread/BakeryBread.png";
import Original from "src/assets/images/home/BakeryBread/BakeryBread4.png";
import Chocolate from "src/assets/images/home/BakeryBread/BakeryBread1.png";
import Sandwiche from "src/assets/images/home/BakeryBread/BakeryBread2.png";
import Hawaiian from "src/assets/images/home/BakeryBread/BakeryBread5.png";
import Augason from "src/assets/images/home/BakeryBread/BakeryBread3.png";

import Honeyglow from "src/assets/images/home/FreshFruits/FreshFruits1.png";
import Apples from "src/assets/images/home/FreshFruits/FreshFruits4.png";
import Strawberries from "src/assets/images/home/FreshFruits/FreshFruits5.png";
import Grapes from "src/assets/images/home/FreshFruits/FreshFruits6.png";
import Canteloupe from "src/assets/images/home/FreshFruits/FreshFruits3.png";
import Avocados from "src/assets/images/home/FreshFruits/FreshFruits7.png";

import SlicedBeef from "src/assets/images/home/MeatSeafood/Meat&Seafood5.png";
import SalmonFillets from "src/assets/images/home/MeatSeafood/Meat&Seafood6.png";
import StripSteak from "src/assets/images/home/MeatSeafood/Meat&Seafood1.png";
import CookedPeeled from "src/assets/images/home/MeatSeafood/Meat&Seafood3.png";
import BonelessChicken from "src/assets/images/home/MeatSeafood/Meat&Seafood4.png";
import RibsBoneless from "src/assets/images/home/MeatSeafood/Meat&Seafood2.png";

export interface IRecommendProduct {
  readonly id: number;
  name: string;
  logoBrand: string;
  time: number;
  ranking: number;
  nbVote: number;
  img: string;
  price: number;
  priceOrigin?: number;
  quantity: number;
  category: string;
  type?: string;
  grocery: number;
}

export class ShopsFactory {
  static getNearYou() {
    return [
      {
        id: 1,
        name: "Lotte Mart",
        time: 30,
        ranking: 4.7,
        nbVote: 1000,
        img: ImagesHomeNearYou3,
      },
      {
        id: 2,
        name: "VinMart",
        time: 35,
        ranking: 4.5,
        nbVote: 1000,
        img: ImagesHomeNearYou2,
      },
      {
        id: 3,
        name: "Teekiu Mart",
        time: 40,
        ranking: 4.5,
        nbVote: 1000,
        img: ImagesHomeNearYou1,
      },
    ];
  }

  static getAllProductRecommend(): Array<IRecommendProduct> {
    return [
      {
        id: 23,
        logoBrand: FujiLogo,
        name: "Sliced Beef Plate Super Slim 1.5mm",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: SlicedBeef,
        price: 21000,
        quantity: 0,
        category: "Meat & SeaFood",
        grocery: 1,
      },
      {
        id: 24,
        logoBrand: HaproLogo,
        name: "Fresh Atlantic Salmon Fillets",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: SalmonFillets,
        price: 21000,
        quantity: 0,
        category: "Meat & SeaFood",
        grocery: 1,
      },
      {
        id: 25,
        logoBrand: GoLogo,
        name: "Beef Choice Angus NY Strip Steak",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: StripSteak,
        price: 21000,
        quantity: 0,
        category: "Meat & SeaFood",
        grocery: 1,
      },
      {
        id: 26,
        logoBrand: VinLogo,
        name: "Cooked Peeled & Deveined Shrimp",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: CookedPeeled,
        price: 21000,
        quantity: 0,
        category: "Meat & SeaFood",
        grocery: 1,
      },
      {
        id: 27,
        logoBrand: FujiLogo,
        name: "Boneless Chicken Thigh",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: BonelessChicken,
        price: 21000,
        quantity: 0,
        category: "Meat & SeaFood",
        grocery: 1,
      },
      {
        id: 28,
        logoBrand: TeekiuLogo,
        name: "Pork Country Style Ribs Boneless",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: RibsBoneless,
        price: 21000,
        quantity: 0,
        category: "Meat & SeaFood",
        grocery: 1,
      },
      {
        id: 29,
        logoBrand: GoLogo,
        name: "Honeyglow Sweet Pineapple",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Honeyglow,
        price: 21000,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
      {
        id: 30,
        logoBrand: VinLogo,
        name: "Washington Fuji Apples",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Apples,
        price: 21000,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
      {
        id: 31,
        logoBrand: HaproLogo,
        name: "Fresh Strawberries",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Strawberries,
        price: 21000,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
      {
        id: 32,
        logoBrand: LotteLogo,
        name: "Organic Black Seedless Grapes",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Grapes,
        price: 21000,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
      {
        id: 33,
        logoBrand: FujiLogo,
        name: "Organic Tuscan Canteloupe",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Canteloupe,
        price: 21000,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
      {
        id: 34,
        logoBrand: TeekiuLogo,
        name: "Organic Hass Avocados ",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Avocados,
        price: 21000,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },

      {
        id: 42,
        logoBrand: FujiLogo,
        name: "Lemon Pound Cake Mix with...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: LemonPound,
        price: 58500,
        quantity: 0,
        category: "Bakery & Bread",
        type: "new",
        grocery: 1,
      },
      {
        id: 43,
        logoBrand: TeekiuLogo,
        name: "Original Pretzel Crisps",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Original,
        price: 84171,
        priceOrigin: 100000,
        quantity: 0,
        category: "Bakery & Bread",
        type: "sales",
        grocery: 1,
      },
      {
        id: 44,
        logoBrand: LotteLogo,
        name: "Chocolate Crème Cookies",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Chocolate,
        price: 151900,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 45,
        logoBrand: HaproLogo,
        name: "M&M'S Cookie Sandwiches...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Sandwiche,
        price: 49500,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 46,
        logoBrand: GoLogo,
        name: "Hawaiian Sweet No Knead Bread Mix...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Hawaiian,
        price: 113272,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 47,
        logoBrand: VinLogo,
        name: "Augason Farms Honey White Bread...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Augason,
        price: 323100,
        priceOrigin: 350000,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
    ];
  }

  static getRecommendMeatSeafood(): Array<IRecommendProduct> {
    return [
      {
        id: 48,
        logoBrand: FujiLogo,
        name: "Sliced Beef Plate Super Slim 1.5mm",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: SlicedBeef,
        price: 372159,
        quantity: 0,
        category: "Meat & Seafood",
        grocery: 1,
      },
      {
        id: 49,
        logoBrand: HaproLogo,
        name: "Fresh Atlantic Salmon Fillets",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: SalmonFillets,
        price: 163768,
        quantity: 0,
        category: "Meat & SeaFood",
        grocery: 1,
      },
      {
        id: 50,
        logoBrand: GoLogo,
        name: "Beef Choice Angus New York Strip Steak",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: StripSteak,
        price: 418500,
        quantity: 0,
        category: "Meat & Seafood",
        grocery: 1,
      },
      {
        id: 51,
        logoBrand: VinLogo,
        name: "Great Value Frozen Cooked Extra...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: CookedPeeled,
        price: 173910,
        quantity: 0,
        category: "Meat & SeaFood",
        grocery: 1,
      },
      {
        id: 52,
        logoBrand: FujiLogo,
        name: "Marketside Antibiotic - Free Boneless...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: BonelessChicken,
        price: 150660,
        quantity: 0,
        category: "Meat & SeaFood",
        grocery: 1,
      },
      {
        id: 53,
        logoBrand: TeekiuLogo,
        name: "Pork Country Style Ribs Boneless",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: RibsBoneless,
        price: 138570,
        quantity: 0,
        category: "Meat & SeaFood",
        grocery: 1,
      },
    ];
  }

  static getRecommendFreshFruitFood() {
    return [
      {
        id: 54,
        logoBrand: GoLogo,
        name: "Del Monte Honeyglow Sweet...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Honeyglow,
        price: 22000,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
      {
        id: 55,
        logoBrand: VinLogo,
        name: "Washington Fuji Fresh Apples",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Apples,
        price: 163768,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
      {
        id: 56,
        logoBrand: HaproLogo,
        name: "Fresh Strawberries Bag Pack",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Strawberries,
        price: 163768,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
      {
        id: 57,
        logoBrand: LotteLogo,
        name: "Organic Fantasy Seedless Grape",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Grapes,
        price: 186918,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
      {
        id: 58,
        logoBrand: FujiLogo,
        name: "Tuscan Cantaloupe - Super-Sweet...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Canteloupe,
        price: 62565,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
      {
        id: 59,
        logoBrand: TeekiuLogo,
        name: "Organic Hass Avocados",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Avocados,
        price: 55000,
        quantity: 0,
        category: "Fresh Fruit",
        grocery: 1,
      },
    ];
  }

  static getRecommendSearch(): Array<IRecommendProduct> {
    return [
      {
        id: 60,
        logoBrand: GoLogo,
        name: "Cake",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: ImageExample,
        price: 21000,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 61,
        logoBrand: VinLogo,
        name: "Cake",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: ImageExample,
        price: 21000,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 62,
        logoBrand: HaproLogo,
        name: "Cake",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: ImageExample,
        price: 21000,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 63,
        logoBrand: LotteLogo,
        name: "Cake",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: ImageExample,
        price: 21000,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 64,
        logoBrand: FujiLogo,
        name: "Cake",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: ImageExample,
        price: 21000,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 65,
        logoBrand: TeekiuLogo,
        name: "Cake",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: ImageExample,
        price: 21000,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 66,
        logoBrand: TeekiuLogo,
        name: "Banana",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: ImageExample,
        price: 21000,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
    ];
  }

  static getRecommendBakeryBread(): Array<IRecommendProduct> {
    return [
      {
        id: 67,
        logoBrand: FujiLogo,
        name: "Lemon Pound Cake Mix with...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: LemonPound,
        price: 58500,
        quantity: 0,
        category: "Bakery & Bread",
        type: "new",
        grocery: 1,
      },
      {
        id: 68,
        logoBrand: TeekiuLogo,
        name: "Snack Factory® Original Pretzel Crisps",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Original,
        price: 84171,
        priceOrigin: 100000,
        quantity: 0,
        category: "Bakery & Bread",
        type: "sales",
        grocery: 1,
      },
      {
        id: 69,
        logoBrand: LotteLogo,
        name: "Dare Fudge Chocolate Crème Cookies...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Chocolate,
        price: 151900,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 70,
        logoBrand: HaproLogo,
        name: "M&M'S Cookie Sandwiches...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Sandwiche,
        price: 49500,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 71,
        logoBrand: GoLogo,
        name: "Krusteaz Hawaiian Sweet No Knead...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Hawaiian,
        price: 113272,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
      {
        id: 72,
        logoBrand: VinLogo,
        name: "Augason Farms Honey White Bread...",
        time: 25,
        ranking: 4.5,
        nbVote: 201,
        img: Augason,
        price: 323100,
        priceOrigin: 350000,
        quantity: 0,
        category: "Bakery & Bread",
        grocery: 1,
      },
    ];
  }

  static getHotPromos() {
    return [
      {
        id: "1",
        logoBrand: LotteLogoEllipe,
        codeDiscount: "LTM15",
        discount: 15,
        useFor: "Bakery & Snack",
        expires: "2022/01/30",
        grocery: 1,
      },
      {
        id: "2",
        logoBrand: TeekiuLogoEllipe,
        codeDiscount: "TKM10",
        discount: 10,
        useFor: "Dairy & Eggs",
        expires: "2022/01/30",
        grocery: 1,
      },
      {
        id: "3",
        logoBrand: GoLogoEllipe,
        codeDiscount: "GOM25",
        discount: 25,
        useFor: "Fresh Fruits",
        expires: "2022/01/30",
        grocery: 1,
      },
      {
        id: "4",
        logoBrand: HPMLogoEllipe,
        codeDiscount: "HPM5",
        discount: 5,
        useFor: "Health Care",
        expires: "2022/01/30",
        grocery: 1,
      },
      {
        id: "5",
        logoBrand: VinLogoEllipe,
        codeDiscount: "VNM5",
        discount: 5,
        useFor: "Meat & Sea Food",
        expires: "2022/01/30",
        grocery: 1,
      },
    ];
  }
}
